/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigModel, AzureAdSettings } from './models';

@Injectable()
export class AppConfig {
  private config: AppConfigModel = null;
  constructor(private httpClient: HttpClient) {
  }
  public getConfig(key: any) {
    return this.config[key];
  }

  getAdalConfig(): AzureAdSettings {
    return this.config.azureAd;
  }

  getApiBaseUrl(): string {
    return this.config.apiBaseUrl;
  }
  getApiUrl(): string {
    return this.config.apiUrl;
  }

  load() {
    return new Promise((resolve) => {
      this.httpClient.get(`/api/lookup/frontend-configuration`,
          {
            headers: {
              'skip-adal': 'true'
            }
          }
        )
        .subscribe((responseData: AppConfigModel) => {
          this.config = responseData;
          this.config.azureAd.redirectUri = window.location.origin + '/';
          console.log("app.config: " + this.config.azureAd.redirectUri);
          resolve(true);
        });
    });
  }
}
